import { Box, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useMemo, useState } from "react";
import AreaChart from "src/components/ScoringChart/AreaChart";
import { beautifulTooltip } from "src/components/ScoringChart/tool-utils/BeautifulTooltip";
import TitleTypography from "src/components/Typography/TitleTypography";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { useReputationSelector } from "src/context/reputationContext";
import { numberWithCommas, toFixed } from "src/services/utils";
import LockHoverButton from "../LockHoverButton";

const useStyle = makeStyles((theme) => ({
  root: {
    padding: "20px",
    position: "relative",
    minHeight: 300,
  },
  balanceText: {
    color: theme.palette.primary.main,
    fontSize: "18px",
    fontWeight: 500,
    paddingLeft: "0.5rem",
  },
  balanceFigure: {
    color: theme.palette.primary.secondary,
    fontSize: "28px",
    fontWeight: 500,
  },
  dateText: {
    color: theme.palette.text.hint,
    fontSize: "14px",
    fontWeight: 400,
  },
  fogContent: {
    filter: "blur(4px)",
  },
}));

const getOption = () => ({
  chart: {
    height: 260,
  },
  xAxis: {
    type: "datetime",
    tickAmount: 3,
  },
  yAxis: {
    tickAmount: 6,
    labels: {
      enabled: true,
    },
  },
  ...beautifulTooltip((value) => numberWithCommas(toFixed(value, 2))),
});

export default function TravaBalance({ isEmpty, onBuyTRAVAClick }) {
  const cls = useStyle();

  const [isShowLock, setShowLock] = useState(true);

  const reputationUser = useReputationSelector((state) => state.reputationUser);

  const { series, isLoading } = useMemo(() => {
    if (reputationUser) {
      const category = Object.keys(reputationUser.balanceHistory);
      const dataChart = Object.values(reputationUser.balanceHistory);
      const data = category.map((item, index) => [item * 1000, dataChart[index]]);
      const series = [{ name: "Balance", data: data }];
      return { series: series, isLoading: false };
    } else {
      return { series: [], isLoading: true };
    }
  }, [reputationUser]);

  return (
    <PaperWrapper
      title="TRAVA Balance"
      onMouseEnter={() => setShowLock(false)}
      onMouseLeave={() => setShowLock(true)}
      paperProps={{ className: cls.root }}
    >
      <Box width="100%" height="100%" className={clsx({ [cls.fogContent]: isEmpty })}>
        {reputationUser ? (
          <AreaChart series={series} isLoading={isLoading} option={getOption()} />
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <TitleTypography textProps={{ variant: "h4" }} title="Please connect your wallet first!" />
          </Box>
        )}
      </Box>
      {isEmpty && <LockHoverButton isShowLock={isShowLock} onBuyTRAVAClick={onBuyTRAVAClick} />}
    </PaperWrapper>
  );
}
